<template>
  <div style="width: 100%;height: 100%;" id="container"></div>
</template>

<script>
import remoteLoad from '@/utils/remoteLoad'
export default {
  data() {
    return {
      AutoNaviMap: null,
      this: [],
    }
  },
  watch: {},
  //DOM树之前触发 异步加载有问题  index 全局加载
  async created() {
    // 高德地图API判断，已加载初始化地图
    if (window.AMap && window.AMapUI) {
      this.mapInit('container')
    } else {
      // 未载入高德地图API，则先载入API再初始化
      // await remoteLoad(`//cache.amap.com/lbs/static/es5.min.js`)
      await remoteLoad(
        `//webapi.amap.com/maps?v=1.4.15&key=2cbb0fe7670495938085430e3825062a&plugin=AMap.MarkerClusterer,AMap.Geocoder`
      )
      this.mapInit('container')
    }
  },

  mounted() {
    // this.mapInit('container');
  },
  methods: {
    mapInit(domName) {
      this.AutoNaviMap = new window.AMap.Map(domName, {
        resizeEnable: true, //是否监控地图容器尺寸变化
        // center: [113.280637, 23.125178], //初始化地图中心点  //如果center属性缺省，地图默认定位到用户所在城市的中心
        // mapStyle: 'amap://styles/b7bbc06eb4e2b351d9a0066d0a38d3ae',
        zoom: 13, //初始化地图层级
      })

      // // 同时引入工具条插件，比例尺插件和鹰眼插件
      // AMap.plugin([
      //     'AMap.ToolBar',
      //     'AMap.Geolocation',
      // ], function(){
      //     // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
      //     this.AutoNaviMap.addControl(new AMap.ToolBar());
      //     // 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
      //     this.AutoNaviMap.addControl(new AMap.Geolocation());
      // });

      // this.handlePolygon('双流')//勾勒地区



      this.$emit('amapDone') //完成加载 通知父组件
    },
    //点击地图选点
    setpoint(){
      var aa,marker = null
      //为地图注册click事件获取鼠标点击出的经纬度坐标
      this.AutoNaviMap.on('click', (e) => {
        var longitude = e.lnglat.getLng()
        var latitude = e.lnglat.getLat()
        var coordinate = e.lnglat.getLng() + ',' + e.lnglat.getLat()
        console.log(longitude, latitude, coordinate)
        // $("#longitude").val(longitude);
        // $("#latitude").val(latitude);
        // $("#coordinate").val(coordinate);

        marker = new window.AMap.Marker({
          // icon: "http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
          position: [longitude, latitude],
          // offset: new AMap.Pixel(-13, -30),
          // title: coordinate[i].name,
          // map: map
        })
        if (aa) {
          this.AutoNaviMap.remove(aa)
        }
        aa = marker
        marker.setMap(this.AutoNaviMap)
 
        this.regeoCode(coordinate)
      })
    },






    //通过经纬度查询地址
    regeoCode(lnglat) {
      var geocoder = new window.AMap.Geocoder({
        // city: "010", //城市设为北京，默认：“全国”
        // radius: 1000 //范围，默认：500
      })
      geocoder.getAddress(lnglat,  (status, result) =>{
        if (status === 'complete' && result.regeocode) {
          var address = result.regeocode.formattedAddress
          console.log(address);
          // $('#md_addr').val(address)
          this.$emit('site',[lnglat,address])//传给父组件
        } else {
          console.error('根据经纬度查询地址失败')
        }
        
      })
    },

    myclearMap() {
      // 清除地图上所有添加的覆盖物
      this.AutoNaviMap.clearMap()
    },

    //画行政区边界
    handlePolygon(area) {
      this.$nextTick(() => {
        //获取边界坐标点
        window.AMap.plugin('AMap.DistrictSearch', () => {
          var districtSearch = new window.AMap.DistrictSearch({
            level: 'province', // 关键字对应的行政区级别，共有5种级别
            subdistrict: 0, //  是否显示下级行政区级数，1表示返回下一级行政区
            extensions: 'all', // 返回行政区边界坐标点
          })
          // 搜索所有省/直辖市信息
          districtSearch.search(area, (status, result) => {
            // 查询成功时，result即为对应的行政区信息
            if (status == 'complete') {
              //画轮廓
              let bounds = result.districtList[0].boundaries
              if (bounds) {
                for (let i = 0, l = bounds.length; i < l; i++) {
                  //生成行政区划polygon
                  let polygon = new window.AMap.Polygon({
                    map: this.AutoNaviMap, // 指定地图对象
                    strokeWeight: 1, // 轮廓线宽度
                    path: bounds[i], //轮廓线的节点坐标数组
                    fillOpacity: 0.15, //透明度
                    fillColor: '#256edc', //填充颜色
                    strokeColor: '#256edc', //线条颜色
                  })
                  polygon.on('click', (e) => {
                    // 点击绘制的区域时执行其他交互
                    // ......
                    console.log(e)
                  })
                }
                // 地图自适应
                this.AutoNaviMap.setFitView()
              }
            }
          })
        })
      })
    },
    //标点
    punctuationArr(arr) {
      // 创建一个 Marker 实例：
      // var marker = new AMap.Marker({
      //     position: new AMap.LngLat(31.099796,104.411361),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      //     title: '北京'
      // });

      // 将创建的点标记添加到已有的地图实例：
      // this.AutoNaviMap.add(marker);

      // 移除已创建的 marker
      // map.remove(marker);

      var icon = new window.AMap.Icon({
        size: new window.AMap.Size(40, 50), // 图标尺寸
        image:
          '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png', // Icon的图像
        imageSize: new window.AMap.Size(30, 40), // 根据所设置的大小拉伸或压缩图片
      })
      var markers = []

      for (const iterator of arr) {
        if (iterator.longitude != '' && iterator.longitude !== null) {
          //标点
          let marker = new window.AMap.Marker({
            icon: icon,
            position: [iterator.longitude, iterator.latitude],
            offset: new window.AMap.Pixel(-13, -30),
            title: iterator.companyName,
            clickable: true,
          })

          //窗口html
          // var content = `
          //     <div ><div><img style='float:left;' src=' https://webapi.amap.com/images/autonavi.png'/></div>
          //     <div style='padding:7px 0px 0px 0px;'><h4>${iterator.companyName}</h4>
          //     <p class=''>电话 : 010-84107000   邮编 : 100102</p>
          //     <p class=''>地址 :北京市朝阳区望京阜荣街10号首开广场4层</p></div></div>
          // `;

          // 窗体信息
          let infoWindow = new window.AMap.InfoWindow({
            content: `<h5  style = 'color:#3d93fd;padding: 10px;'>${iterator.companyName}</h5>`, //使用默认信息窗体框样式，显示信息内容
            offset: new window.AMap.Pixel(0, -20),
          })

          //给标记点添加点击事件
          marker.on('click', () => {
            //给每一个点位增加点击事件
            infoWindow.open(
              this.AutoNaviMap,
              // 窗口信息的位置
              marker.getPosition(iterator.longitude, iterator.latitude)
            )
          })
          // AMap.event.addListener(marker, 'click', (e)=>{
          //     console.log("1111",e)
          // });
          //添加监听事件，关闭信息窗体
          window.AMap.event.addListener(this.AutoNaviMap, 'zoomend', () => {
            // 关闭信息窗体
            this.AutoNaviMap.clearInfoWindow(infoWindow)
          })
          markers.push(marker)
        }
      }

      if (this.cluster) {
        this.cluster.setMap(null)
      }

      this.cluster = new window.AMap.MarkerClusterer(
        this.AutoNaviMap,
        markers,
        {
          gridSize: 80,
        }
      )

      // markers.setMap(this.AutoNaviMap);
    },
    //单个点标记
    punctuation(arr=[104.256859,31.180339]) {

      var icon = new window.AMap.Icon({
        size: new window.AMap.Size(40, 50), // 图标尺寸
        image:
          '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png', // Icon的图像
        imageSize: new window.AMap.Size(30, 40), // 根据所设置的大小拉伸或压缩图片
      })      
      // 创建一个 Marker 实例：
      var marker = new window.AMap.Marker({
        icon: icon,
        position: arr,   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '德阳'
      });

      this.AutoNaviMap.setCenter(arr); //设置地图中心点

      // 将创建的点标记添加到已有的地图实例：
      this.AutoNaviMap.add(marker);

      // 移除已创建的 marker
      // map.remove(marker);


      // markers.setMap(this.AutoNaviMap);
    },    
  },
}
</script>

<style scoped>
</style>
